<template>
  <div>
    <h1>New Video</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>

    <VideoForm
      :handle-submit="onSendForm"
      :values="item"
      :errors="violations" />

    <router-link
      :to="{ name: 'VideoList' }"
      class="btn btn-primary mt-3">Back to list</router-link>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import VideoForm from './Form';

const { mapFields } = createHelpers({
    getterType: 'video/create/getField',
    mutationType: 'video/create/updateField',
});

export default {
  components: {
    VideoForm,
  },

  data () {
    return {
      item: {},
    };
  },

  computed: {
    ...mapFields([
      'error',
      'isLoading',
      'created',
      'violations',
    ]),
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return;
      }

      this.$router.push({ name: 'VideoList', params: { id: created['@id'] } });
    }
  },

  methods: {
    ...mapActions('video/create', [
      'create',
    ]),

    onSendForm () {
      this.create(this.item);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/video/Create.vue